import { FunctionComponent, memo } from "react";
import { IProps } from "./phrase-trigger-translation-sentence.types";
import { LoadingCell } from "@edgetier/client-components";
import "./phrase-trigger-translation-sentence.scss";

/**
 * Display the sentence or a translated sentence for phrase triggers samples / results
 * @param props.sentence            Current phrase trigger sample / results sentence
 * @param props.activeTranslation   Translation for a phrase trigger sample / results sentence
 */
const PhraseTriggerTranslationSentence: FunctionComponent<IProps> = ({ sentence, activeTranslation }) => (
    <>
        {typeof activeTranslation !== "undefined" ? (
            <div className="phrase-trigger-translation-sentence">
                {activeTranslation.isLoading ? (
                    <LoadingCell />
                ) : (
                    <>
                        {activeTranslation.isTranslated && activeTranslation.translatedText.trim().length > 0
                            ? activeTranslation.translatedText
                            : sentence}
                    </>
                )}
            </div>
        ) : (
            <div className="phrase-trigger-translation-sentence">{sentence}</div>
        )}
    </>
);

export default memo(PhraseTriggerTranslationSentence);
